import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { DisplayServiceDetailsInvoice, InvoiceDemandLists, ServiceDetailsInvoice } from '../../../../../Administration/src/app/business-entities/service-detail-invoice-view-model';
import { GlobalService } from '../../helper/Services/global.service';
import { AppointmentDetailsTracker, AppointmentKeyModel } from '../../Models/appointmentDetailsTrackerModel';
import { CarParkingService } from '../../Services/carparking/car-parking.service';
import { OrderStatusService } from '../../Services/orderstatus/order-status.service';
import { PaymentGatewayService } from '../../Services/orderstatus/payment-gateway.service';
import { CustomerDealerDeatail, DealerBrandViewModel, DealerDetailsListViewModel, DealerOpeningHoursViewModel, DealerViewModel, ServiceDetails } from '../pdf-view/invoice-details.model';
import { PdfViewComponent } from './../pdf-view/pdf-view.component';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { Features } from '../../../../../Widget/src/app/business-entities/step.class';
import * as CommonEnums from '../../../../../Autofacets-Core/src/app/utils/enums';
import { CurrentLanguage } from '../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppointmentAdditionalServiceDetails } from '../../Models/AppointmentAdditionalServiceDetails';
import { PostedInvoiceList } from 'projects/Administration/src/app/business-entities/invoice-model';
import saveAs from 'file-saver';
import { DocumentUploadService } from 'projects/Autofacets-Core/src/app/common-services/document-upload.service';
declare let Dibs: any;

@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.css']
})
export class OrderStatusComponent implements OnInit {
  activeId = "third";
  getOTP = false;
  otp = {
    digit1: '',
    digit2: '',
    digit3: '',
    digit4: '',
    digit5: '',
    digit6: ''
  };

  @ViewChild(PdfViewComponent) pdfComponent: PdfViewComponent;
  @ViewChild('orderConfirm') orderConfirm: any;
  @ViewChild('orderArrival') orderArrival: any;
  @ViewChild('arrivalToPickup') arrivalToPickup: any;
  @ViewChild('payment') payment: any;
  @ViewChild('paymentSuccess') paymentSuccess: any;
  @ViewChild('authenticateModal') authenticateModal: any;
  servicesDetails: ServiceDetails[] = [];
  statusConfigData: any[];
  orderInfo: any;
  orderServiceinfo: any;
  popupCloseResult = false;
  orderAdditionalinformation: any;
  orderAdditionalinfo: any;
  isAdditionalInformation = false;
  isAdditionalinfo = false;
  isServiceAvailable = false;
  isArrivedForPickup = false;
  clickCount = 0;
  exceptedTime: any;
  exceptedDate: any;
  signatureImage: any;
  servicePrice: any;
  minutes = 5;
  seconds = 0;
  pdfTypeId: any;
  interval: any;
  displayResendcodeButton = false;
  timerColsed = true;
  customerEmail = '';
  resendCodeCount = 0;
  timer = new Date().setMinutes(4, 59);
  currentAppointment: any;
  statusInterval: any;
  isAuthenticated = false;
  signatureValue: any;
  isSignature: boolean = false
  currencyType: any;
  currentTheme: any;
  currentLanguage: any;
  phoneNo: any;
  status: any[];
  statusCount: number;
  statusDegree: number;
  static counter: any = 0;
  count: number = 0;
  statusTrackerInterval: number = 300000;
  showData = false;
  imageSrc: string;
  grandTotal = 0;
  createdDate: any;
  bookedDate: any;
  previewType: number = 1;
  DiscountWithPrecision: any;
  serviceDetail: ServiceDetailsInvoice;
  dealerDetailsListViewModel: DealerDetailsListViewModel;
  invoiceData: DisplayServiceDetailsInvoice[] = [];
  showMinusRoundOff: boolean = false;
  roundOff: number;
  WOStatus: any;
  showInvoiceSection: boolean = false;
  showParkingSection: boolean = false;
  showShareboxSection: boolean = false;
  isDmsActive: boolean = false;
  carParkingDetails: any;
  url: string;
  isPaymentEnable: boolean = false;
  isPaymentFeatureEnable: boolean = false;
  contactDetails: AppointmentDetailsTracker = {
    appointmentId: 0,
    address: "",
    bookedDate: null,
    color: "",
    companyModel: "",
    createdDate: null,
    customerName: "",
    dealerBrand: "",
    dealerName: "",
    engineNumber: "",
    licensePlate: "",
    mechanicId: 0,
    modelName: "",
    plannedMechanics: "",
    registrationDate: "",
    updatedDate: null,
    vehicleId: "",
    price: null,
    vehicleType: "",
    year: 1999,
    discount: 0,
    isPickUpDropOffService: false,
    pickUpDateTime: null,
    companyMakeName: "",
    companyMakeCode: "",
    isAutoKey: false,
    isKeyDrop: false,
    isCheckIn: false,
    rentalLicensePlate: "",
      rentalCompanyMakeName: "",
      workorderStatusId: 0,
    appointmentKeyList: [],
  };
   isAppointmentOnHold:boolean=false;
  customerDealerDetails: CustomerDealerDeatail = {
    CustomerId: undefined,
    CustomerName: undefined,
    CustomerAddress1: undefined,
    CustomerAddress2: undefined,
    EmailId: undefined,
    MobileNo: undefined,
    DealerName: undefined,
    DealerAddress1: undefined,
    DealerAddress2: undefined,
    DealerEmailId: undefined,
    DealerMobileNo: undefined,
    OPENINGHRS: undefined,
    Country: undefined,
    LandlineNo: undefined,
    CompanyMake: undefined,
    CompanyModel: undefined,
    LicensePlateNo: undefined,
    OrderNumber: undefined,
    OrderStatus: undefined,
    OpeningHours: '',
    DealerCity: '',
    DealerPinCode: ''
  };
  dealerDetails: DealerViewModel = {
    adUserId: "",
    address1: "",
    address2: "",
    city: "",
    country: "",
    dealerId: "",
    dealershipsId: 0,
    email: "",
    franchiseId: 0,
    id: 0,
    isActive: true,
    isActiveForWidget: false,
    keyLocation: true,
    vehiclePickupDropoffService: true,
    name: "",
    landline: 12,
    mobile: 154,
    onlinePayment: true,
    pincode: "",
    state: "",
    unitPrice: '45',
    customerWaitingLimit: 0,
    bankAccountNumber: "",
    companyNumber: "",
  };
  dealerAllBrands: DealerBrandViewModel[];
  dealerOpeningHours: DealerOpeningHoursViewModel[];
  OrderStatusDetail: any;
  mechanicKeyDropInfo: AppointmentKeyModel = null;
  customerKeyDropInfo: AppointmentKeyModel = null;
  features: Features[] = [];
  EnableCookieConsent:boolean = false;
  pdfUrl: string | undefined;
  trustedBlobUrl: SafeResourceUrl;
  postedInvoiceList: PostedInvoiceList[];
  totalCount = 0;
  invoiceFileContents: any;
  additionalServiceDetail:AppointmentAdditionalServiceDetails;
  noRecords=false;
  isCustomerKeyPickInfo: boolean = false;
  invoiceGenerateDmsSide: boolean = false;
  allowInvoiceGeneration: boolean = false;
  parkingImageToShow: string = '/assets/images/loading.svg';
  imgSources = [];
  apiBaseUrl = `${EnvSetting.STATUS_TRACKER_BASE_API_URL}Document`;

  constructor(
    private gService: GlobalService,
    public orderService: OrderStatusService,
    private carParkingService: CarParkingService,
    private toasterService: ToastrService,
    private spinner: NgxSpinnerService,
    private cdf: ChangeDetectorRef,
    private translate: TranslateService,
    private cookieService: CookieService,
    private modalService: NgbModal,
    private datepipe: DatePipe,
    private paymentGatewayService: PaymentGatewayService,
    private cdr: ChangeDetectorRef,
    private globalSetting: GlobalSetting,
    private currentLng:CurrentLanguage,
    private sanitizer: DomSanitizer,
    private readonly documentUploadService: DocumentUploadService,
  ) { }
  /**
   * Init method is part of the Page life crycle
   * so this will execute when page will load
   */
  async ngOnInit(): Promise<void> {
    this.postedInvoiceList = [];
    this.currentLng.featureList.subscribe((response) => {
      if(response?.length > 0){
        this.EnableCookieConsent = response?.find(x => x.featureCode === CommonEnums.FeatureCode.EnableCookieConsent)?.isActive;
        this.showShareboxSection = response?.find(x => x.featureCode === CommonEnums.FeatureCode.ShareBox)?.isActive;
        if(this.EnableCookieConsent){
          let node = document.createElement('script');
          node.src = EnvSetting.Tracker_CookieScript_Key;
          node.type = 'text/javascript';
          document.getElementsByTagName('head')[0].appendChild(node);
         }
        this.isDmsActive = response?.find(x => x.featureCode === CommonEnums.FeatureCode.DMS)?.isActive;
      }
    })
    this.currentAppointment = this.gService.getAppInitialData;
    if (this.currentAppointment) {
      await this.GetAppointmentDetail(this.currentAppointment.AppointmentGuid);
      this.getVehicleParkedLocationDetails();
    }
  }
  // async GetAll() {
  //   await this.GetAppointmentDetail(this.currentAppointment.AppointmentGuid);
  //   // below method Moved into above method's finally section
  //   //await this.GetServiceDetail();
  //   //await this.getDealerDetails();
  // }

  async getVehicleParkedLocationDetails() {
    this.spinner.show();
    await this.carParkingService.getVehicleParkedLocationImage().then(res => {
      if (res !== null) {
        this.carParkingDetails = res;
        this.url = res.imagePath;
        this.ViewParkingImage(res.imagePath);
      } else {
        this.url = null;
      }
    }).finally(()=>{
      this.spinner.hide();
    });
  }

  
  async ViewParkingImage(url: string) {
    const exists = this.imgSources.find(x=>x.name == url);
    if (exists) {
      this.parkingImageToShow = exists.base64;
    }
    else{
      this.parkingImageToShow = '/assets/images/loading.svg';
      await this.documentUploadService.GetDemandViewFile(`${this.apiBaseUrl}/View`, url).then((res) => {
        if (res) {
          this.parkingImageToShow = res;
          this.imgSources.push({ name: url, base64: res });
        }
        else{
          this.parkingImageToShow = "assets/no-image-icon.png";
        }
      }, (_err)=>{
        this.parkingImageToShow = "assets/no-image-icon.png";
      });
    }    
  }

  async GetAppointmentDetail(_Id: string) {
    await this.orderService.GetAppointmentDetail().then(async result => {
      if (result.responseCode == Enums.ErrorCodes.SuccessCode) {
        this.contactDetails = result.responseObject;
        this.isAppointmentOnHold=this.contactDetails.workorderStatusId === Enums.WOStatus.OnHold; 
        if(this.contactDetails.workorderStatusId == Enums.WOStatus.Workdone || this.contactDetails.workorderStatusId == Enums.WOStatus.InvoicePaid 
          || this.contactDetails.workorderStatusId == Enums.WOStatus.Invoiceready || this.contactDetails.workorderStatusId == Enums.WOStatus.Closed
        )
        {
            this.isCustomerKeyPickInfo = true;
        }       
        this.createdDate = this.contactDetails.createdDate;
        this.contactDetails.createdDate = this.createdDate;
        this.bookedDate = this.contactDetails.bookedDate;
        this.contactDetails.bookedDate = this.bookedDate;
        this.WOStatus = this.contactDetails.workorderStatusId;
        if (this.contactDetails.discount) {
          this.DiscountWithPrecision = this.contactDetails.discount.toFixed(2);
        }
        if (this.contactDetails.pickUpDateTime) {
          //conver from utc to local
          let latest_date = this.datepipe.transform(this.contactDetails.pickUpDateTime, 'yyyy-MM-dd HH:mm:ss');
          let yourDate: Date = new Date(latest_date + ' UTC');
          this.contactDetails.pickUpDateTime = yourDate;
        }

        this.pdfTypeId = Enums.PdfType.Invoice;
        this.paymentButtonStatus();
        if (this.showInvoiceSection) {
          await this.getInvoiceDetail()
          await this.GetPostedInvoiceList();
        }
      }
    }).finally(()=>{
      this.GetServiceDetail();
      this.GetAdditionalServiceDetails();
    });

    this.getKeyDropInfo();
  }

  async GetAdditionalServiceDetails(){
    this.spinner.show();
    await this.orderService.GetAdditionalServiceDetail().then(data => {
        if (data.responseObject ?.errorCount > 0) {
          this.additionalServiceDetail = {
            appointmentAdditionalDemandList:[],
            appointmentAdditionalJobList:[],
            appointmentAdditionalJobDetailList:[]
          }
          this.noRecords = true;
        }
        else {
          this.noRecords = false;
           this.additionalServiceDetail=data.responseObject;
        }
    }).finally(()=>{
      this.activeId+=",four";
      this.spinner.hide();
    })
  }

  paymentButtonStatus(){
    if (this.WOStatus === Enums.WOStatus.Invoiceready || this.WOStatus === Enums.WOStatus.InvoicePaid || this.WOStatus === Enums.WOStatus.Closed) {
      if (this.contactDetails.isAutoKey || this.contactDetails.isKeyDrop) {
        this.isPaymentEnable = false;
      } else {
        //changes are done by dharmendra on 15 july 2024 after concluded with Hiral. payment only be enable for cash and contact.
        if(this.WOStatus === Enums.WOStatus.Invoiceready && this.contactDetails.paymentType === Enums.PaymentType.B2C){
          this.isPaymentEnable = true;
        }else{
          this.isPaymentEnable = false;
        }
      }
      if(this.WOStatus === Enums.WOStatus.Invoiceready)
      {
        this.activeId = "first"
      }
      this.previewType = 1
      this.pdfTypeId = Enums.PdfType.Invoice;
      this.showInvoiceSection = true;
      this.showParkingSection = true;
    }
    else {
      this.isPaymentEnable = false;
      this.showInvoiceSection = false;
      this.previewType = 0;
      this.pdfTypeId = Enums.PdfType.OrderConfirmationWithPrice;
      this.showParkingSection = this.WOStatus === Enums.WOStatus.Workdone;
    }
  }

  async GetServiceDetail() {
    this.spinner.show();
    await this.orderService.getOrderStatusDetails().then(res => {
      if (res) {
        this.orderService.repairActualStatusId.next(res.repairStatusDetails.repairStatusId);
        if(res.repairStatusDetails.repairStatusId == Enums.WOStatus.OnHold)
        {
          this.orderService.previousStatusId.next(res.repairStatusDetails.previousRepairStatusId)
        }
        this.OrderStatusDetail = res;
      }
    }).finally(async ()=>{
      await this.getDealerDetails();
      this.spinner.hide();
    });
  }

  private async getInvoiceDetail() {
    this.spinner.show();
    await this.orderService.GetDetailForInvoice(this.pdfTypeId).then(data => {
      if (data.responseObject?.errorCount > 0) {
        this.serviceDetail = {
          invoiceDemandLists: [],
          invoiceJobLists: [],
          invoiceJobDetailsLists: [],
          invoicePriceLists: null,
          filePath:null
        }
      }
      else {
        this.serviceDetail = data.responseObject;
        if (this.serviceDetail.invoiceDemandLists?.length > 0) {
          this.invoiceData = [];
          this.serviceDetail.invoiceDemandLists.forEach(demand => {
            let joblist = this.serviceDetail.invoiceJobLists.filter(x => x.demandNo === demand.demandNo);
            let jobDetailList = this.serviceDetail.invoiceJobDetailsLists.filter(x => x.demandNo === demand.demandNo);
            if (joblist && jobDetailList) {
              let demandObj: InvoiceDemandLists;
              let idata: DisplayServiceDetailsInvoice = {
                invoiceDemand: demandObj,
                invoiceJobLists: [],
                invoiceJobDetailsLists: []
              }
              idata.invoiceDemand = demand;
              idata.invoiceJobLists = joblist;
              idata.invoiceJobDetailsLists = jobDetailList;
              this.invoiceData.push(idata);
            }
          });
        }
        if (this.serviceDetail?.invoicePriceLists?.length > 0) {
          if (this.serviceDetail.invoicePriceLists[0].roundOff < 0) {
            this.showMinusRoundOff = true;
            this.roundOff = Math.abs(this.serviceDetail.invoicePriceLists[0].roundOff);
          }
          else {
            this.roundOff = this.serviceDetail.invoicePriceLists[0].roundOff;
          }
        }
      }
    }).finally(()=>{
      this.spinner.hide();
    });
  }

  showImage(data) {
    if (OrderStatusComponent.counter === 0) {
      const sign = data;
      OrderStatusComponent.counter = OrderStatusComponent.counter + 1;
      this.isSignature = false;
      this.signatureValue = sign;
    } else if (this.signatureValue === data) {
      this.isSignature = false;
    } else if (this.isSignature === false && this.signatureValue != data) {
      this.isSignature = true;
    } else {
      this.isSignature = false;
    }
    this.signatureImage = data;
    this.cdf.detectChanges();
  }

  async getDealerDetails() {
    this.spinner.show();
    await this.orderService.getDealerDetails().then((response) => {
      if (response?.responseObject) {
        this.dealerDetailsListViewModel = response.responseObject;
        this.dealerDetails = this.dealerDetailsListViewModel.dealerDetails;
        this.dealerAllBrands = this.dealerDetailsListViewModel.dealerBrandList;
        this.dealerOpeningHours = this.dealerDetailsListViewModel.dealerHours;
        if (this.dealerDetails?.onlinePayment) {
          this.CheckPayment();
        }
      }
    }).finally(()=>{
      this.spinner.hide();
    });;
  }

  /**
   * Purpose of the method is to display invoice in a pdf format
   */
  onViewInvoice(content) {
    const modalRef = this.modalService.open(content, {
      //windowClass: 'customize-content',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });

    modalRef.result.then((_result) => {
      //modal result
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
    })
  }



  /**
   * Common method to close modal
   * @param modal
   */
  onCloseModal(modal) {
    modal.dismiss('Cross click');
    this.isSignature = false;
    this.cdf.detectChanges();
  }

  /**
   * For get and resend OTP
   */
  // onAuthenticateYourself() {
  //   this.spinner.show();
  //   if (this.isCookiesExist()) {
  //     this.currentLanguage = (this.cookieService.get('userSelectedLanguage')).toString();
  //   } else {
  //     this.currentLanguage = KeyValue.DefaultLanguage;
  //   }
  //   let param = {
  //     AppointmentId: this.currentAppointment.AppointmentId,
  //     Language: this.currentLanguage
  //   }
  //   this.orderService.authenticateYourself(param).subscribe(() => {
  //     this.getOTP = true;
  //     this.spinner.hide();
  //     let otpmsg = this.translate.instant("lblOTPSendMsg");
  //     this.toasterService.success(otpmsg);
  //     this.startTimer();
  //   }, () => {
  //     let otperrormsg = this.translate.instant("lblOTPErrorMsg");
  //     this.toasterService.error(otperrormsg);
  //     this.spinner.hide();
  //   });
  // }



  onSubmit() {
    const otp = this.otp.digit1 + this.otp.digit2 + this.otp.digit3 + this.otp.digit4 + this.otp.digit5 + this.otp.digit6;
    if (otp.length !== 6) {
      let otpentermsg = this.translate.instant("lblOTPEnterMsg");
      this.toasterService.error(otpentermsg);
      return;
    }
    const model = {
      Otp: +otp,
      Date: new Date().toUTCString()
    };
    this.orderService.validateOTP(model).subscribe(() => {
      let otpvrifictionmsg = this.translate.instant("lblVerificationMsg");
      this.toasterService.success(otpvrifictionmsg);
      this.isAuthenticated = true;
      this.getOTP = false;
      this.timerColsed = true;
    }, error => {
      if (error.error) {
        this.toasterService.error(error.error);
      } else {
        let errormsg = this.translate.instant("lblErrormsg");
        this.toasterService.error(errormsg);
      }
    });
  }

  startTimer() {
    this.timerColsed = false;
    this.displayResendcodeButton = false;
    this.timer = new Date().setMinutes(4, 59);
    const expireTime = new Date(new Date().getTime() + 5 * 60000);
    this.interval = setInterval(() => {
      const time = new Date();
      const diff = expireTime.getTime() - time.getTime();
      if (diff <= 0) {
        this.timerColsed = true;
        if (this.resendCodeCount < 1) {
          this.displayResendcodeButton = true;
        }
        clearInterval(this.interval);
      }
      this.timer = new Date(diff).setMinutes(diff / 60000);
    }, 1000);
  }

  checkOTP(): boolean {
    return this.otp.digit1.length !== 6;
  }

  getOrderStatus(statusCode: number): { code: number, text: string, step: number } {
    const obj: { code: number, text: string, step: number } = { code: undefined, text: undefined, step: undefined };
    while (true) {
      this.statusConfigData.forEach(element => {
        if (element.id === statusCode) {
          obj.code = element.id;
          obj.text = element.keyValue;
          obj.step = +(element.step as string).slice(element.step.length - 1);
        }
      });
      if (obj.code !== undefined) {
        break;
      }
      statusCode = statusCode - 1;
      if (statusCode === 0) {
        break;
      }
    }
    return obj;
  }

  canDisplayBtn(id: number) {
    return this.statusConfigData.findIndex(x => x.id === +id) !== -1;
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  //#region Payment Methods

  CheckPayment() {
    this.spinner.show();
    this.paymentGatewayService.checkPayment().subscribe(
      (next: any) => {
        this.isPaymentFeatureEnable = next;
      },
      (_err?: any) => {
        this.isPaymentFeatureEnable = false;
      },
      () => {
        this.spinner.hide();
      }
    );
  }
  OnInvoicePayment(content) {
    this.currentLanguage = (this.cookieService.get('userSelectedLanguage'))?this.cookieService.get('userSelectedLanguage'):EnvSetting.LANGUAGE_CONFIG.defaultLanguage;
    this.spinner.show();
    this.paymentGatewayService.invoicePayment().subscribe(
      (next: any) => {
        if (next?.paymentId && next?.checkoutKey) {
          const modalRef = this.modalService.open(content, {
            //windowClass: 'customize-content',
            size: 'lg',
            backdrop: 'static',
            keyboard: false
          });
          const checkoutOptions = {
            checkoutKey: next.checkoutKey,
            paymentId: next.paymentId,
            containerId: "invoice-checkout-container",
            language: (this.currentLanguage)?this.currentLanguage:EnvSetting.LANGUAGE_CONFIG.defaultLanguage
          };
          const checkout = new Dibs.Checkout(checkoutOptions);
          const _this = this;
          modalRef.result.then(
            (_result) => {
              checkout.cleanup();
            },
            (_reason) => {
              checkout.cleanup();
            });
            this.globalSetting.signalrConnectionTracker
            .subscribe((connection)=>{
              if (connection) {
                connection.on(Enums.SignalRHubEventType.UpdateAppointmentStatus, (_data) => {
                  this.DismissPayment();
                });
              }
            });
          checkout.on('payment-completed', function (response) {
            modalRef.close();
            checkout.cleanup();
            _this.PaymentCompleted(true, response);
          });
          this.spinner.hide();
        } else {
          this.PaymentCompleted(false, next);
        }
      },
      (err?: any) => {
        this.PaymentCompleted(false, err);
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  PaymentCompleted(IsSuccess, response) {
    this.spinner.hide();
    if (IsSuccess) {
      this.isPaymentEnable = false;
      this.toasterService.success(Enums.ToastrMessages.PaymentSuccess);
      this.ngOnInit();
      this.cdr.detectChanges();
    } else {
      switch (response) {
        case "NOFEATURE":
          this.toasterService.error(Enums.ToastrMessages.PaymentFeatureError);
          break;
        case "NOPAYMENT":
          this.toasterService.error(Enums.ToastrMessages.PaymentConfigError);
          break;
        default:
          this.toasterService.error(Enums.ToastrMessages.PaymentFailed);
          break;
      }
    }
  }

  DismissPayment(){
    let updatedModalRef = this.modalService.open(ModalDialogComponent, { centered: true, backdrop: 'static', keyboard: false });
    updatedModalRef.componentInstance.modelHeader = this.translate.instant('lblInvoicePaid');
    updatedModalRef.componentInstance.modelBody = this.translate.instant('lblInvoicePaidMsg');
    updatedModalRef.result.then(
      (_result) => {
        this.modalService.dismissAll();
        this.ngOnInit();
        this.cdr.detectChanges();
      },
      (reason) => {
        if (reason) {
          this.modalService.dismissAll();
          this.ngOnInit();
          this.cdr.detectChanges();
        }
      });
  }

  getKeyDropInfo(): void {
    let keyList = this.contactDetails.appointmentKeyList;
    if (keyList && keyList.length > 0) {
      this.exchangeMethod(keyList);
    }
  }

  exchangeMethod(keyList:AppointmentKeyModel[]){
    keyList.forEach(item => {
      if (item.exchangeMethod == 0 && item.user == null) {
        item.keyPickUpDate = item.keyPickUpDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.keyPickUpDate+"Z")) : null;
        item.assignLockerDate = item.assignLockerDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.assignLockerDate+"Z")) : null;
        this.customerKeyDropInfo = item;
      }
      else if (item.exchangeMethod == 1) {
        item.keyPickUpDate = item.keyPickUpDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.keyPickUpDate+"Z")) : null;
        item.assignLockerDate = item.assignLockerDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.assignLockerDate+"Z")) : null;
        this.mechanicKeyDropInfo = item;
      }
    });
  }

  async onPreview(content, base64String: string) {
    if (base64String) {
      let blob = Utility.base64toBlob(base64String, "application/pdf;charset=utf-8");
      this.pdfUrl = URL.createObjectURL(blob);
      this.trustedBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl+'#toolbar=0');

      this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' })
      .result;
    }
  }
  //#endregion

  //#region Preview Invoice Methods
  
  async GetPostedInvoiceList() {
    this.spinner.show();
    this.totalCount = 0;
    let id = this.contactDetails.appointmentId;
    let wo = this.currentAppointment.RepairId;
    await this.orderService.getPostedInvoiceByWo(id, wo).then((response) => {
      this.spinner.hide();
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (response.responseObject.isSuccess) {
          this.postedInvoiceList = response.responseObject.postedInvoiceList;
          this.totalCount = this.postedInvoiceList.length;
        }
        else {
          this.toasterService.error(response.responseObject.resultMessage);
        }
      }
    },
      _error => {
        this.spinner.hide();
      });
  }

  async onPreviewInvoice(invoiceNo : string, previewModal = null){
    this.spinner.show();
    this.invoiceFileContents = null;
    let LanguageCode = (this.cookieService.get('userSelectedLanguage'))?this.cookieService.get('userSelectedLanguage'):EnvSetting.LANGUAGE_CONFIG.defaultLanguage;
    await this.orderService.getInvoiceDocument(invoiceNo, LanguageCode).then((response) => {
      this.spinner.hide();
      if (response.responseCode === Constant.SuccessResponseCode) {
        this.invoiceFileContents = response.responseObject;
        this.onPreview(previewModal, response.responseObject.fileContents);
      } else {
        this.toasterService.error(response.responseMessage);
        this.spinner.hide();
      }
    },
      _error => {
        this.spinner.hide();
      });
  }

  onDownloadInvoice() {
    if (this.invoiceFileContents) {
      let blob = Utility.base64toBlob(this.invoiceFileContents?.fileContents, "application/pdf;charset=utf-8");
      saveAs(blob, this.invoiceFileContents?.fileDownloadName);
    }
  }
  //#endregion
}

